import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ProfileService } from './service/profile.service';
import { Profile } from '../core/models/profile';

@Component({
  selector: 'app-profile-home',
  templateUrl: './profile-home.component.html',
  styleUrls: ['./profile-home.component.scss']
})
export class ProfileHomeComponent implements OnInit {

  @Output() sendReloader = new EventEmitter<boolean>();

  public urlBanner: string;
  public nameUrl: string;
  private bannerDefault = '../../assets/svgs/banner.svg';
  public loading = false;

  public tabs = [
    {
      id: 1,
      title: 'Perfil',
      active: false
    }
  ];

  constructor(
    private service: ProfileService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.params.subscribe(x => {
      this.nameUrl = x.name;
      this.loading = true;
      this.service.findByName(x.name).subscribe((profile: Profile) => {
        this.service.sendPerfil(profile);
        this.urlBanner = profile.banner_image_url ? profile.banner_image_url : this.bannerDefault;
      }, () => this.router.navigate(['/nao-encontrado']), () => this.loading = false);
    });
  }

  public selectTab(event: Params) {
    if (event.id === 1) {
      this.router.navigate([`perfil/${this.nameUrl}/perfil`]);
      return false;
    }
  }
}
